export enum RegisterUserSteps {
    NewRegistration = 0,
    BankIdVerification = 1,
    BisnodeVerification = 2,
    Contacts = 3,
    SecurityAndTerms = 4,
    Confirmation = 5,
    Welcome = 6,
}